//
//
//
//
//
//
//
//
//
//
//
//

import BaseCmsBlock from '../../node_modules/sitis-nuxt/lib/cms/CmsBlockMixin'
import Faq from "~/components/faq/Faq.vue"
export default BaseCmsBlock.extend({
  name: "FaqBlock",

  data: function () {
    return {
      apiItems: [],
      isLoadApiItems: false
    }
  },

  computed: {
    items: function () {
      if (this.isUseApi) {
        return this.apiItems
      }

      return this.extras.items
    },

    isUseApi: function () {
      return this.externalData?.FaqBlock?.useApi || false
    },
    isVisible: function () {
      return Boolean(this.items.length > 0)
    }
  },

  components: {
    Faq
  },

  fetch: async function () {
    if (this.isUseApi) {
      await this.getApiItems();
    }
  },
  watch: {
    externalData: async function () {
      if (this.isUseApi) {
        await this.getApiItems();
      }
    }
  },

  methods: {
    getApiItems: async function () {
      let search = [];

      if (!this.externalData?.FaqBlock?.categoryId && !this.externalData?.FaqBlock?.productId && !this.externalData?.FaqBlock?.filterPageId || this.isLoadApiItems) {
        return
      }

      if (this.externalData?.FaqBlock?.categoryId) {
        search.push(`category_id=${this.externalData?.FaqBlock?.categoryId}`);
      }
      if (this.externalData?.FaqBlock?.productId) {
        search.push(`product_id=${this.externalData?.FaqBlock?.productId}`);
      }
      if (this.externalData?.FaqBlock?.filterPageId) {
        search.push(`filter_page_id=${this.externalData?.FaqBlock?.filterPageId}`);
      }
      const response = await this.$api.agent.transport.get(`/faq?${search.join('&')}`).then((res) => {
        return res.data
      }).catch(() => {
        return []
      })
      this.apiItems = response;
      this.isLoadApiItems = true;
    },
  }
})
